import type { FC } from 'react';
import GenericReportMobile from '../_partials/GenericReportMobile';
import { useTranslation } from 'react-i18next';
import TopCustomersTableRowHeadingMobile from './TopCustomersTableRowHeadingMobile';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';
import TopCustomersActionMenu from '../../../TopCustomersSection/TopCustomersActionMenu';

import s from './TopCustomersMobile.scss';

const PRO_ONLY_DISPLAY_LIMIT = 3;
const INITIAL_VISIBLE_COUNT = 5;

export default function TopCustomersMobile() {
  const { t } = useTranslation();

  const columns = [
    {
      key: 'uniqueProducts',
      label: t(
        'studio.reports.section.topCustomers.table.header.uniqueProducts'
      ),
      className: s['products-sold'],
    },
    {
      key: 'totalSales',
      label: t('studio.reports.common.table.header.totalSales'),
    },
    {
      key: 'salesVolume',
      label: t('studio.reports.common.table.header.salesVolume'),
      format: formatDollars,
      className: s['sales-volume'],
    },
  ];

  return (
    <GenericReportMobile
      reportType="topCustomers"
      headingKey="studio.reports.section.topCustomers.title"
      descriptionKey="studio.reports.section.topCustomers.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={t(
              'studio.reports.section.topCustomers.description.learnMoreLink.url'
            )}
          >
            {t(
              'studio.reports.section.topCustomers.description.learnMoreLink.text'
            )}
          </a>
        ),
      }}
      columns={columns}
      RowHeading={TopCustomersTableRowHeadingMobile}
      RowExtras={RowExtrasWrapper}
      proOnlydisplayLimit={PRO_ONLY_DISPLAY_LIMIT}
      initialVisibleCount={INITIAL_VISIBLE_COUNT}
    />
  );
}

interface RowExtrasWrapperProps {
  item: any;
}

const RowExtrasWrapper: FC<RowExtrasWrapperProps> = ({ item }) => {
  return <TopCustomersActionMenu user={item.user} />;
};
